import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Contact from './Contact';
import SiteNavigation from '../containers/SiteNavigation';
import Articles from '../containers/Articles';

const onTouchStart = (e) => {
  const target = e.target;
  const startTopScroll = target.scrollTop;
  if (startTopScroll <= 0) {
    target.scrollTop = 1;
  }
  if (startTopScroll + target.offsetHeight >= target.scrollHeight) {
    target.scrollTop = target.scrollHeight - target.offsetHeight - 1;
  }
};

class Section extends React.Component {

  componentDidMount() {
    ReactDOM.findDOMNode(this).focus();
  }

  componentWillReceiveProps(props) {
    if (props.location.pathname.substring(3) !== this.props.location.pathname.substring(3)) {
      ReactDOM.findDOMNode(this).scrollTop = 0;
    }
  }

  render() {
    const { lang } = this.props;
    return (
      <section
        key="section"
        onTouchStart={onTouchStart}
        tabIndex="-1"
        // className={classNames({ appear: visible, disappear: !visible })}
      >
        <div className="sectionContainer">
          <Articles lang={lang} />
          <SiteNavigation lang={lang} />
          <Contact lang={lang} />
        </div>
      </section>
    );
  }
}

Section.propTypes = {
  lang: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
};

export default Section;



// WEBPACK FOOTER //
// ./common/components/Section.js